(function () {
    'use strict';

    angular.module('app').directive('fodbzValidation', FodbzValidationDirective);
    function FodbzValidationDirective() {
        return {
            require: '^ngModel',
            // eslint-disable-next-line angular/no-directive-replace
            replace: true,
            scope: {
                fodbzErrors: '=',
                fodbzRole: '@',
                formErrorRequired: '@',
                formErrorUrl: '@',
                formErrorMinlength: '@',
                formErrorMaxlength: '@',
                formErrorEmail: '@',
                formErrorGetal: '@',
                formErrorMin: '@',
                formErrorMax: '@',
                formErrorDate: '@'
            },
            controller: ValidationDirectiveController,
            template: '<div ng-messages="fodbzErrors" style="color:red" role="{{fodbzRole}}">\
                        <div ng-message="required">{{formErrorRequired}}</div>\
                        <div ng-message="url">{{formErrorUrl}}</div>\
                        <div ng-message="minlength">{{formErrorMinlength}}</div>\
                        <div ng-message="maxlength">{{formErrorMaxlength}}</div>\
                        <div ng-message="email">{{formErrorEmail}}</div>\
                        <div ng-message="number">{{formErrorGetal}}</div>\
                        <div ng-message="min">{{formErrorMin}}</div>\
                        <div ng-message="max">{{formErrorMax}}</div>\
                        <div ng-message="date">{{formErrorDate}}</div>\
                      </div>'
        };
    }

    ValidationDirectiveController.$inject = ['$scope', '$rootScope',];
    function ValidationDirectiveController($scope, $rootScope) {
        $scope.formErrorRequired = angular.isDefined($scope.formErrorRequired) ? $scope.fodbzType : $rootScope.translations.Form_Error_required;
        $scope.formErrorUrl = angular.isDefined($scope.formErrorUrl) ? $scope.fodbzType : $rootScope.translations.Form_Error_url;
        $scope.formErrorMinlength = angular.isDefined($scope.formErrorMinlength) ? $scope.fodbzType : $rootScope.translations.Form_Error_minlength;
        $scope.formErrorMaxlength = angular.isDefined($scope.formErrorMaxlength) ? $scope.fodbzType : $rootScope.translations.Form_Error_maxlength;
        $scope.formErrorEmail = angular.isDefined($scope.formErrorEmail) ? $scope.fodbzType : $rootScope.translations.Form_Error_email;
        $scope.formErrorGetal = angular.isDefined($scope.formErrorGetal) ? $scope.fodbzType : $rootScope.translations.Form_Error_getal;
        $scope.formErrorMin = angular.isDefined($scope.formErrorMin) ? $scope.fodbzType : $rootScope.translations.Form_Error_Min;
        $scope.formErrorMax = angular.isDefined($scope.formErrorMax) ? $scope.fodbzType : $rootScope.translations.Form_Error_Max;
        $scope.formErrorDate = angular.isDefined($scope.formErrorDate) ? $scope.fodbzType : $rootScope.translations.Form_Error_Date;
    }
})();
